// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"CompressDropdownMenu_dropdown__1EpKe","dropdow":"CompressDropdownMenu_dropdow__1rFfk","button":"CompressDropdownMenu_button__Y-6rP"};